module.exports = __webpack_public_path__ + "static/media/yt-boat.1aadd44a.mov";